import { Skeleton } from "src/components"
import { OfferListTableHead } from "./OfferListTableHead"

export const OfferListSkeleton = () => {
	return (
		<Skeleton.Table
			data-testid="offer-overview"
			caption="Offer List"
			tableHead={<OfferListTableHead />}
			columns={9}
			rows={4}
		/>
	)
}
